import { getAPIBaseURL } from "../api/api";
import useUserStore from "../stores/useUserStore";
import EmailVerification from "supertokens-auth-react/recipe/emailverification";
import Session from "supertokens-auth-react/recipe/session";
import ThirdPartyEmailPassword, { Github, Google } from "supertokens-auth-react/recipe/thirdpartyemailpassword";

const sendSignupConversionEvent = (email: string): void => {
  const scriptId = "gtm-conversions";
  if (!document.getElementById(scriptId)) {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-EQY56DJHF6";
    script.async = true;
    script.id = scriptId;
    document.head.appendChild(script);

    script.onload = () => {
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      w.gtag =
        w.gtag ||
        function () {
          w.dataLayer.push(arguments);
        };
      w.gtag("js", new Date());
      w.gtag("config", "G-EQY56DJHF6");
      w.gtag("event", "conversion", {
        send_to: "AW-11239971658/rsR2CKC6q_YYEMq20e8p",
        value: checkEmailDomain(email),
        currency: "USD",
      });
      setTimeout(() => {
        document.head.removeChild(script);
      }, 5000);
    };
  }
};

const checkEmailDomain = (email: string) => {
  const commonEmailDomains = new Set([
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "msn.com",
    "live.com",
    "comcast.net",
    "sbcglobal.net",
    "verizon.net",
    "zoho.com",
    "mail.com",
    "ymail.com",
    "me.com",
    "protonmail.com",
    "cox.net",
    "att.net",
    "bellsouth.net",
    "earthlink.net",
    "charter.net",
    "optonline.net",
    "shaw.ca",
    "ntlworld.com",
    "orange.net",
    "web.de",
    "proton.me",
  ]);
  const domain = email.split("@")[1];
  return commonEmailDomains.has(domain) ? 1.0 : 20.0;
};

export function getApiDomain() {
  return getAPIBaseURL("v1");
}

export function getWebsiteDomain() {
  return window.location.origin;
}

export const superTokensConfig = {
  appInfo: {
    appName: "TableFlow",
    apiDomain: getApiDomain(),
    websiteDomain: getWebsiteDomain(),
  },
  // recipeList contains all the modules that you want to
  // use from SuperTokens. See the full list here: https://supertokens.com/docs/guides
  recipeList: [
    ThirdPartyEmailPassword.init({
      useShadowDom: false,
      resetPasswordUsingTokenFeature: {
        disableDefaultUI: true,
      },
      signInAndUpFeature: {
        providers: [Github.init(), Google.init()],
        disableDefaultUI: true,
      },
      onHandleEvent: (context: any) => {
        const user = {
          id: context?.user?.id,
          email: context?.user?.email,
          isNewUser: context?.isNewUser,
        };
        useUserStore.setState({
          user,
        });

        switch (context.action) {
          case "SUCCESS":
            // Sign in
            const user = context.user;
            if ("posthog" in window) {
              const postHog = window["posthog"] as any;
              postHog.identify(user.id, { email: user.email }, {});
            }
            // if ("$chatwoot" in window) {
            //   const chatwoot = window["$chatwoot"] as any;
            //   chatwoot.setUser(user.id, {
            //     email: user.email,
            //     name: user.email,
            //   });
            // }
            if (context.isNewUser) {
              // Sign up
              if ("posthog" in window) {
                const postHog = window["posthog"] as any;
                postHog.capture("Signup", {
                  $set_once: { created_at: new Date().toISOString() },
                });
              }
              sendSignupConversionEvent(user.email);
            }
            break;
        }
      },
    }),
    EmailVerification.init({ mode: "REQUIRED", disableDefaultUI: true }),
    Session.init(),
  ],
};
